import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import { setVideoUrl } from 'actions/video';
import { IDENTIFY_IBAN, IDENTIFY_TRANSFER, IDENTIFY_VIDEO_CALL } from 'constants/actionTypes';
// @ constants
import { TRANSFER_CERTIFICATE, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { BASE_PATH } from 'constants/index';
import { EXTERNAL_IBAN, LIMIT_CREDIT_INE } from 'constants/statusProcess';
import { CREDIT_CARD, ROBO } from 'constants/userProfile';
import { PROGRAMMED, START } from 'constants/video/status';
import { formatText } from 'core/i18n';
import { actions } from 'react-redux-form';
import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { history } from 'routes/history';
import { post } from 'utilities/APIRequestHelper';
import { VIDEOSELFIE_CAPTURE } from 'constants/featureFlagging';

const { recordEvent, RELIABLE, PAGE_PRODUCT, errorTag, recordEventStepSuccess } = require('utilities/uTagging');

const {
    PATH_IDENTITY,
    PATH_IDENTITY_VIDEOCALL,
    PATH_IDENTITY_VIDEOSELFIE,
    IDENTITY_VIDEOS_RECORD_TAG,
} = require('constants/uTagConstants/paths');
const {
    ERROR_CASO_IBAN,
    ERROR_CASO_TRANSFERENCIA,
    ERROR_CASO_VIDEOLLAMADA,
    ERROR_CASO_VIDEOSELFIE,
} = require('constants/analyticsErrors');

const { change } = actions;

export const getStoreReducers = props => props;

function* identifyIban({ iban, identityIban, userProfile, ibanOnline, polling }) {
    let ibanOnlineValidation = false;

    try {
        yield put(showPreLoader());
        const { investmentType } = userProfile;
        const requestData = {
            query: {
                iban,
            },
        };

        ibanOnline &&
            (requestData.query = { ...requestData.query, acceptedText: formatText('identify-ibanTermsClause') });
        yield call(post, 'clientIdentificationIban', requestData);
        ibanOnline && (ibanOnlineValidation = true);

        yield all([
            ibanOnline
                ? put(change('userProfile.ibanOnlineValidation', true))
                : put(change('userProfile.identified', true)),
            investmentType === CREDIT_CARD && put(change('userProfile.status', LIMIT_CREDIT_INE)),
            put(change('userProfile.identityStatus', PROGRAMMED)),
            put(change('userProfile.identityIban', identityIban)),
        ]);
    } catch (error) {
        const {
            response: { body: bodyError, statusCode },
        } = error;
        bodyError && errorTag(bodyError, PATH_IDENTITY, ERROR_CASO_IBAN, statusCode);
        yield put(() => history.push(`${BASE_PATH}/errors`));
    } finally {
        if (ibanOnline && ibanOnlineValidation) polling.startOnlineIbanPolling();
        else yield put(hidePreLoader());
    }
}

function* identifyTransfer({ userProfile, docNumberEncrypted }) {
    try {
        yield put(showPreLoader());

        const { recordId, userId, investmentType } = userProfile;
        const response = yield call(post, 'postTransfercertificate');
        const {
            body: { onboardingStatus },
        } = response;
        yield all([
            put(change('userProfile.identityMethod', TRANSFER_CERTIFICATE)),
            put(change('userProfile.status', onboardingStatus)),
            investmentType === ROBO
                ? put(change('userProfile.identified-robo', true))
                : put(change('userProfile.identified', true)),
        ]);
        recordEvent(
            PATH_IDENTITY,
            PAGE_PRODUCT,
            'validacion por transferencia',
            'validacion por transferencia correcto',
            recordId,
            userId,
            RELIABLE[TRANSFER_CERTIFICATE],
            investmentType,
            docNumberEncrypted
        );

        recordEventStepSuccess(investmentType, 'identidad/transferencia', 'identificacion transferencia');
    } catch (error) {
        const {
            response: { body: bodyError, statusCode },
        } = error;
        bodyError && errorTag(bodyError, PATH_IDENTITY, ERROR_CASO_TRANSFERENCIA, statusCode);
        yield put(() => history.push(`${BASE_PATH}/errors`));
    } finally {
        yield put(hidePreLoader());
    }
}

function* identifyVideo({ date, videoCallType, urlCallType, language, investmentType, acceptedText }) {
    try {
        const flags = yield select(state => state.featureFlagging?.get('data'));
        if (!flags.get(VIDEOSELFIE_CAPTURE) || videoCallType !== VIDEO_SELFIE) {
            yield put(showPreLoader());
            const requestData = {
                query: {
                    acceptedText,
                },
            };
            const response = yield call(post, urlCallType, requestData);
            const {
                body: { url },
            } = response;

            const VIDEO_URL = {
                [VIDEO_CALL]: `${url}&language=${language}`,
                [VIDEO_SELFIE]: `${url}?language=${language}`,
            };
            const videoUrl = VIDEO_URL[videoCallType];
            yield put(setVideoUrl(videoUrl));
        }

        const { currentday, currentMonth, monthName, currentYear, currentHour, currentminutes } = date;

        const identityTypeName = IDENTITY_VIDEOS_RECORD_TAG[videoCallType];

        yield all([
            investmentType === CREDIT_CARD && put(change('userProfile.status', EXTERNAL_IBAN)),
            put(change('userProfile.identityMethod', videoCallType)),
            put(change('userProfile.videoFinishByUser', false)),
            put(change('userProfile.identityStatus', START)),
            put(change('userProfile.videoCallDay', currentday)),
            put(change('userProfile.videoCallMount', currentMonth)),
            put(change('userProfile.videoCallMountName', monthName)),
            put(change('userProfile.videoCallYear', currentYear)),
            put(change('userProfile.videoCallHour', currentHour)),
            put(change('userProfile.videoCallminutes', currentminutes)),
        ]);

        recordEventStepSuccess(
            investmentType,
            `identidad/${identityTypeName}/comienzo`,
            `comienzo ${identityTypeName}`
        );
    } catch (error) {
        const {
            response: { body: bodyError, statusCode },
        } = error;

        const VIDEO_TAGS = {
            [VIDEO_CALL]: { path: PATH_IDENTITY_VIDEOCALL, error: ERROR_CASO_VIDEOLLAMADA },
            [VIDEO_SELFIE]: { path: PATH_IDENTITY_VIDEOSELFIE, error: ERROR_CASO_VIDEOSELFIE },
        };

        const videoTagsErrorObject = VIDEO_TAGS[videoCallType];

        bodyError && errorTag(bodyError, videoTagsErrorObject.path, videoTagsErrorObject.error, statusCode);
        yield put(() => history.push(`${BASE_PATH}/errors`));
    } finally {
        yield put(hidePreLoader());
    }
}

function* identify() {
    yield all([
        takeLatest(IDENTIFY_IBAN, identifyIban),
        takeLatest(IDENTIFY_TRANSFER, identifyTransfer),
        takeLatest(IDENTIFY_VIDEO_CALL, identifyVideo),
    ]);
}

export default [identify];
